import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { apiFetch } from '../utils/api';

const ProtectedManagerRoute = () => {
  const [isManager, setIsManager] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkManager = async () => {
      const userEmail = localStorage.getItem('userEmail');
      if (!userEmail) {
        setIsManager(false);
        setLoading(false);
        return;
      }
      try {
        const data = await apiFetch(`${window._env_.API_BASE_URL}/users/info?email=${userEmail}`);
        setIsManager(data.isManager === true);
      } catch (err) {
        setIsManager(false);
      } finally {
        setLoading(false);
      }
    };
    checkManager();
  }, [location.pathname]);

  if (loading) return null; // or a spinner
  if (!isManager) {
    sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/Login" replace />;
  }
  return <Outlet />;
};

export default ProtectedManagerRoute;